import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Check } from 'lucide-react';

const TrackerSteps = ({ steps }) => {
  const getCircleClasses = (status) => {
    switch (status) {
      case 'completed':
        return 'bg-blue-500 border-blue-500 text-white';
      case 'current':
        return 'bg-blue-500 border-blue-500 text-white';
      default:
        return 'bg-white border-gray-300 text-gray-300';
    }
  };

  const getLabelClasses = (status) => {
    switch (status) {
      case 'completed':
      case 'current':
        return 'text-blue-500 font-semibold';
      default:
        return 'text-gray-400';
    }
  };

  const getLineClasses = (status) => (
    status === 'completed' ? 'bg-blue-500' : 'bg-gray-200'
  );

  return (
    <div className="flex-1 mx-auto max-w-full w-[780px] px-4 sm:px-0 sm:mb-12">
      <div className="flex sm:hidden items-center justify-between">
        {steps.map((step, index) => (
          <Fragment key={step.number}>
            <div className="flex flex-col items-center gap-2 z-10 w-[74px]">
              <div
                className={`flex-shrink-0 w-8 h-8 rounded-full border-2 flex items-center justify-center text-sm font-bold ${getCircleClasses(step.status)}`}
              >
                {step.status === 'completed'
                  ? <Check className="h-4 w-4" strokeWidth={3} />
                  : step.number}
              </div>
              <span className={`text-xs whitespace-nowrap ${getLabelClasses(step.status)}`}>
                {step.title}
              </span>
            </div>
            {index < steps.length - 1 && (
              <div className={`flex-1 -mx-3 h-[2px] mb-6 ${getLineClasses(step.status)}`} />
            )}
          </Fragment>
        ))}
      </div>

      <div className="hidden sm:block">
        <div className="flex items-center justify-between">
          {steps.map((step, index) => (
            <Fragment key={step.number}>
              <div className="flex items-center gap-2 z-10">
                <div
                  className={`flex-shrink-0 w-12 h-12 rounded-full border-2 flex items-center justify-center text-xl font-bold ${getCircleClasses(step.status)}`}
                >
                  {step.status === 'completed'
                    ? <Check className="h-6 w-6" strokeWidth={3} />
                    : step.number}
                </div>
                <span className={`text-sm font-semibold whitespace-nowrap ${getLabelClasses(step.status)}`}>
                  {step.title}
                </span>
              </div>
              {index < steps.length - 1 && (
                <div className={`flex-1 mx-4 h-[2px] ${getLineClasses(step.status)}`} />
              )}
            </Fragment>
          ))}
        </div>
      </div>
    </div>
  );
};

TrackerSteps.propTypes = {
  steps: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default TrackerSteps;
